import React, { useState, useEffect } from 'react';
import { useRouteMatch, withRouter } from 'react-router-dom';
import axios from 'axios';
import spinner from './loading-spinner.gif';
import Output from './Output';
import { Event } from './Tracking';

const ProductDetail = (props) => {
	const [product, setProduct] = useState(null);
	const [ingredients, setIngredients] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	let match = useRouteMatch();
	const storeId = process.env.AMAZON_STORE_ID;
	let _isMounted = false;

	useEffect(() => {
		const productId = Number(match.params.productId);
		_isMounted = true;
		setLoading(true);

		if (!productId) {
			return;
		}

		axios
			.get('/api/products/' + match.params.productId)
			.then( product => {
				if (_isMounted) {
					setProduct(product.data[0]);
					performIngredientsAnalysis(product.data[0].ingredients);
				}
			})
			.catch(err => {
				setProduct(null);
				setLoading(false);
				setError(err.response.data.msg);
			})
	}, []);

	useEffect( () => () => _isMounted = false, [] );

	const performIngredientsAnalysis = (ingredients) => {
		axios
			.get('/api/search', {
				params: {
					ingredients: ingredients
				}
			})
			.then( ings => {
				setIngredients([...ings.data]);
			})
			.catch(err => {
				setIngredients([]);
			});
	}

	useEffect(() => {
		if (!_isMounted) {
			setLoading(false);
		} else {
			setLoading(true);
		}
	}, [ingredients]);

	const shopOnAmazon = (asin) => {
		const redirect = `https://www.amazon.com/gp/product/${asin}/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=${asin}&linkCode=as2&tag=${storeId}&linkId=3daa0db4fe3df2f983344af3b639810d`;

		Event("User", `Clicked to shop for asin: ${asin}`, "Shop on Amazon Button")

		window.open(redirect, '_blank') || window.location.replace(redirect);
	}

	return (
		<React.Fragment>
			{loading ? <img src={spinner} alt="spinner"/> :
				!product ? <p>{error}</p> :
				<div className="row">
					<div className="top-bar"></div>
					<div className="column">
						<div className="product-detail-image-wrapper">
							<img
								className="product-detail-image"
								src={`//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=${product.asin}&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=${storeId}`}
								alt={`${product.brand} ${product.title_preview}`}/>
						</div>
						<button
							onClick={() => shopOnAmazon(product.asin)}
							className="shop-on-amazon">
								Shop on Amazon
						</button>
					</div>
					<div className="double-column">
						<div className="brand">
							{product.brand}
						</div>
						<div className="title-preview">
							{product.title_preview}
					
						</div>
						<div className="ingredients">
							<div className="ingredients-overview">Ingredients</div>
							{product.ingredients}
						</div>
						<Output ingredients={ingredients}/>
					</div>
				</div>
			}
		</React.Fragment>
	);
}

export default withRouter(ProductDetail);



// WEBPACK FOOTER //
// ./src/ProductDetail.jsx